export default __webpack_public_path__ + "static/media/box1_bak.1ffba9c6.png";